import React, { useRef } from 'react'
import { message } from 'antd'
import PageLayout from '@layouts/PageLayout'
import { useHistory, useParams } from 'react-router-dom'
import { useLocalization } from '@contexts/LocalizationContext'
import FormComponent from './Form'
import Fetch from '@components/CRUD/Fetch'
import { client } from '@utils/client'

const Edit = () => {
  const { t } = useLocalization()
  const history = useHistory()
  const fetchRef = useRef(null)
  const params = useParams()
  const handleSubmit = async (data) => {
    try {
      delete data.id
      await client.put(`/blog/${params.id}`, data)
      message.success('สำเร็จ')
      history.push('/blogs')
    } catch (e) {
      message.error('ไม่สำเร็จ')
    }
  }
  const fetch = async () => {
    const data = await client.get(`/blog/${params.id}`).then((res) => res.data)
    return data
  }

  return (
    <Fetch fetch={fetch} ref={fetchRef}>
      {(data) => (
        <PageLayout title={t('article.editScreen.title')} extra={[]}>
          <FormComponent
            isEdit
            handleSubmit={handleSubmit}
            defaultValues={{ ...data, posterImages: data.posterImages || [] }}
          />
        </PageLayout>
      )}
    </Fetch>
  )
}

export default Edit
